import React from "react";
import { Box, Modal, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface TargetOrderCancelSummeryProps {
  brokerImg?: string;
  brokerName?: string | string[];
  userName?: string;
  brokerEmail?: string;
  open: boolean;
  toggle: any;
  type: string;
}

const TargetOrderCancelExecuteSummery = (props: TargetOrderCancelSummeryProps) => {
  const { brokerImg, userName, brokerEmail, open, toggle, type } = props;

  //-------------------------STYLES-------------------
  const theme = useTheme();
  return (
    <Modal
      open={open}
      onClose={() => {
        toggle(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "583px",
          height: "290px",
          borderRadius: "10px",
          paddingBottom: "30px",
          bgcolor: "background.paper",
          boxShadow: 24,
          [theme.breakpoints.down("md")]: {
            width: "80%",
            height: "auto",
          },
        }}
      >
        <Box display="grid">
          <CloseIcon
            onClick={() => {
              toggle(false);
            }}
            sx={{
              justifySelf: "end",
              marginTop: "10px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          />
          <img
            alt="broker avatar"
            style={{
              width: "100px",
              margin: "auto",
              height: "100px",
              borderRadius: "50% ",
              border: `1px solid ${theme.palette.primary.main}`,
            }}
            src={brokerImg}
          />
          <Typography sx={{ margin: "auto", paddingTop: "10px", fontWeight: 600 }}>
            {`Hi ${userName || ""}!`}
          </Typography>
          <Typography
            sx={{
              margin: "auto",
              fontSize: "14px",
              lineHeight: 1.21,
              paddingTop: "10px",
              textAlign: "center",
              paddingLeft: "48px",
              paddingRight: "48px",
            }}
          >
            {`Thank you for placing your request to ${type} your target. I’ve received your request and will update you on your target status soon. You should also receive an email from us regarding this request`}
          </Typography>
          <Typography
            sx={{
              margin: "auto",
              fontSize: "14px",
              lineHeight: 1.21,
              paddingTop: "10px",
              textAlign: "center",
              paddingLeft: "48px",
              paddingRight: "48px",
            }}
          >
            {`If you need to amend your target, please contact me at`} <br />
            <span style={{ fontWeight: 600 }}>{brokerEmail}</span>
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default TargetOrderCancelExecuteSummery;
